import {directive} from 'vue-clickaway'
import CustomDirectives from 'src/services/directives'
/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install (Vue) {
    Vue.directive('click-outside', directive)
    Vue.directive('toggle', CustomDirectives.toggleNextEl)
  }
}

export default GlobalDirectives
